import { DOCUMENT_CATEGORY } from "@src/config/constant";
import { useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import { isMobile } from "react-device-detect";
import VehiclePhotos from "./VehiclePhotos";
import { toast } from "react-toastify";
import secureStorage from "@src/config/encrypt";
import { ValidateFileInput } from "@src/config/helper";
import { useNavigate } from "react-router";
import { ResubmissionProps } from "./interface";
import { useLanguage } from "@src/context/LanguageContext";

export default function DocumentResubmission({
  documentList,
  resubmissionLeadId,
  setDocumentList,
  uploadDocumentFiles,
  addDocumentWeb,
  setLoading,
  updateDocumentStatus,
  isShowResubmitBtn
}: ResubmissionProps) {
  const [deleteDocs, setDeleteDocs] = useState<any[]>([]);
  const navigate = useNavigate()
  const {translations} = useLanguage();

  const getFileMeta = (file: any) => {
    const isFileObj = file instanceof File;
    const rawSrc = isFileObj ? file?.name : file;
    const src = isFileObj ? URL.createObjectURL(file) : file;
    const namePart = rawSrc?.split("?")?.[0] || "";
    const ext = namePart?.split(".")?.pop()?.toLowerCase() || "";
    let fileType = ext;
    if (["csv", "xls", "xlsx"].includes(fileType)) fileType = "excel";
    if (fileType === "doc" || fileType === "docx") fileType = "word";
    return { src, fileType };
  };

  const handleFileUpload = async (e: any, index: number, uploadIndex: number) => {
    let selectedFile = e.target.files;
    let validateFile = await ValidateFileInput(selectedFile);
    if(validateFile) return;
    const updated = structuredClone(documentList);
    const prevFiles = updated[index];
    if(prevFiles?.is_resubmit){
      prevFiles.is_file_resubmit = false
    }
    if (!prevFiles.src) prevFiles.src = [];
    if (!prevFiles.src[uploadIndex]) prevFiles.src[uploadIndex] = {};
    prevFiles.src[uploadIndex] = selectedFile?.[0];;
    updated[index] = prevFiles;
    setDocumentList(updated);
  };
  const removeFile = (index: number, uploadIndex: number) => {
    const updatedDoc = structuredClone(documentList);
    let field =updatedDoc[index];
    if (field?.src[uploadIndex]?.id) {
      const updatedDeletedDocs = structuredClone(deleteDocs);
      if (!updatedDeletedDocs.includes(field.src[uploadIndex].id)) {
        updatedDeletedDocs.push(field.src[uploadIndex].id);
      }
      setDeleteDocs(updatedDeletedDocs);
    }
    field.src.splice(uploadIndex, 1);
    const updated = structuredClone(documentList);
    updated[index] = field;
    setDocumentList(updated);
  };
  const addComment = (index: number, comment: string, subIndex?: number) => {
    const updated = structuredClone(documentList);

    if (updated[index]?.value === DOCUMENT_CATEGORY['vehicle_photos']) {
        if (typeof subIndex === 'number') {
        updated[index].child[subIndex].remark = comment;
        }
    } else {
        updated[index].remark = comment;
    }

    setDocumentList(updated);
  };

  const validateDocs = () => {
    let isValid:boolean = true
    const updatedDocList = structuredClone(documentList)
    updatedDocList.map((item: any, index: number) => {
            
    if(item?.value==DOCUMENT_CATEGORY['vehicle_photos']){
        item?.child?.map((ch:any)=>{ 
            if(ch.is_file_resubmit){
                isValid = false
            } 
        })
    }
    if(item?.value!=DOCUMENT_CATEGORY['vehicle_photos']){          
        if(item?.is_file_resubmit){
            isValid = false
        }    
    }
            
    })
    return isValid;
  }
  const handleSubmit = async () => {
    const isValid = validateDocs();
    if(!isValid) return toast.error(translations?.CREATE_APP?.RESUBMIT_DOC_REQ);
    
    const docUrls: any[] = [];
    setLoading(true)
    for(let doc of documentList){
        if(doc.value===DOCUMENT_CATEGORY['vehicle_photos']){
            doc?.child?.map((row:any)=>{
                row.uploaded_files = row.src
                row.comment = row.remark
            })
        }else{
            doc.uploaded_files = doc.src
            doc.comment = doc.remark
        }
        await uploadDocumentFiles(doc, resubmissionLeadId, docUrls);
    }

    if (docUrls?.length) {

        let { user_data } = secureStorage.getItem("authAgentUserInfo") || {};

        const requestPayload = {
            lead_id: resubmissionLeadId,
            doc_path: docUrls,
            is_resubmit: true,
            created_by: user_data?.id,
            created_by_name: user_data?.name
        };
       
        await addDocumentWeb(requestPayload);

        if(deleteDocs?.length){
        await updateDocumentStatus({
            lead_id: resubmissionLeadId,
            documents: deleteDocs,
        });

        }
    }

    setLoading(false)
    navigate('/dashboard')

  };

  return (
    <div className="container-fluid">
      <div className="top-heading financer-lead-heding insurance-top-filer-heading d-flex">
        <h1>{translations?.CREATE_APP?.DOC_RESUB}</h1>
      </div>
      <div className="row">
        <div className="col-md-12">
    <div className="resummison-main-outer resummison-outer w-100">
     
      <Accordion
        defaultActiveKey="2"
        className="accordian-outer config-accordain"
      >
        {documentList.map((item: any, index: number) => {
          const isChildResubmit =
            item?.value === DOCUMENT_CATEGORY["vehicle_photos"] &&
            item?.child?.some((child: any) => child?.is_resubmit);

          return (
            <Accordion.Item
              eventKey={String(index)}
              key={index}
              className={`doc-item ${item.resubmission ? "error" : "ok"}`}
            >
              <Accordion.Header>
                <div
                  className="upload-heading-text resubmit-tabs"
                  style={{ backgroundColor: item?.color_code }}
                >
                  {
                    <>
                      {
                      // isMobile && 
                      (
                        <span className="doc-upload-icn image-reSubmit-icn">
                          <img src={item?.logo} className="" alt="" />
                        </span>
                      )}
                      <h3>
                        {item.label +
                          ` ${item.label.includes("Other") ? "" : "Documents"}`}
                      </h3>
                    </>
                  }
                </div>
              </Accordion.Header>

              <Accordion.Body>
                <div className="col-md-12">
                {item.is_resubmit && item?.comment && (
                  <div className="resub-note m-lg-t">
                    <b>{translations?.CREATE_APP?.RESUBMIT_NOTE} : </b> {item.comment}
                  </div>
                )}
                </div>

                {item.value == DOCUMENT_CATEGORY["vehicle_photos"] && (
                  <div className="wrapper">
                    <VehiclePhotos
                      index={index}
                      item={item}
                      documentList={documentList}
                      setDocumentList={setDocumentList}
                      addComment={addComment}
                      setDeleteDocs={setDeleteDocs}
                    />

                   
                  </div>
                )}
                {item?.value != DOCUMENT_CATEGORY["vehicle_photos"] && (
                  <>
                    <div className="document-card animation-effect">
                      {Array.from({ length: item.max_upload }).map(
                        (_, uploadIndex) => {

                          const imgObj = item?.src?.[uploadIndex];
                          let file = imgObj?.src;
                          if (!imgObj?.src) file = imgObj;

                          return (
                            <div
                              key={uploadIndex}
                              className="col-md-2 col-xs-6 p-lg-t"
                            >
                              {/* UPLOAD BOX */}
                              {!file && (
                                <div
                                  className="add-document-proof mt-2 m-lg-b"
                                  role="presentation"
                                >
                                  <input
                                    type="file"
                                    name="documents[]"
                                    disabled={!item?.is_resubmit}
                                    onChange={(e: any) =>
                                      handleFileUpload(
                                        e,
                                        index,
                                        uploadIndex,
                                      )
                                    }
                                  />
                                  <i className="ic-add"></i>
                                  <span>{translations?.COMMON_MSG?.UPLOAD}</span>

                                  {/* {!document.is_required && (
                                <span className="optional-txt">(Optional)</span>
                            )}

                            {(document.is_required && document?.error_message) && (
                                <span className="error-txt">{document?.error_message}</span>
                            )} */}
                                </div>
                              )}

                              {/*  PREVIEW BOX */}
                              {file && (
                                <div
                                  className={item?.is_file_resubmit ? "upload-image-proof-ra mt-2 m-lg-b" : "upload-image-proof-r mt-2 m-lg-b"}
                                  id={`upload-image-input-${1}-${uploadIndex}`}
                                >
                                    {
                                        item?.is_resubmit && (
                                            <span
                                                className="close-icn"
                                                onClick={() =>
                                                removeFile(index, uploadIndex)
                                                }
                                            >
                                                
                                                <i className="ic-clearclose"></i>
                                            </span>
                                        )
                                    }

                                  {(() => {
                                    const { src, fileType } = getFileMeta(file);
                                    if (fileType === "jpg" || fileType === "jpeg" || fileType === "png") {
                                      return <img src={src} alt="" />;
                                    }
                                    return (
                                      <a href={src} target="_blank" rel="noreferrer">
                                        <i className={`ic-${fileType}-file f-50`}></i>
                                      </a>
                                    );
                                  })()}
                                </div>
                              )}
                               {item?.is_resubmit && (
                      // <textarea className="comment-box" placeholder="Comment" onChange={(e:any)=>addComment(index,e?.target?.value)} />

                      <div className="row document-remarks textarea-field">
              <fieldset className="form-filed">
                <div className="material">
                  <textarea
                    className="form-input"
                    placeholder=" "
                    onChange={(e: any) => {
                      addComment(index, e.target.value);
                    }}
                  ></textarea>
                  <label data-label={translations?.COMMON_MSG?.COMMENT} className="form-label"></label>
                </div>
              </fieldset>
            </div>
                    )}
                            </div>
                          );
                        },
                      )}
                    </div>
                   
                  </>
                )}
              </Accordion.Body>

              {item.is_resubmit && (
                <div className="resubmission-bar">⚠ {translations?.CREATE_APP?.RESUBMIT_REQUIRED}</div>
              )}
               {isChildResubmit &&
                      item.value === DOCUMENT_CATEGORY["vehicle_photos"] && (
                        <div className="resubmission-bar">
                          ⚠ {translations?.CREATE_APP?.RESUBMIT_REQUIRED}
                        </div>
                      )}
            </Accordion.Item>
          );
        })}
      </Accordion>
      {
        isShowResubmitBtn && 
      <div className="btn-continue btn-bottom-fixed">
                <button className="btn-primary" onClick={()=>handleSubmit()}>{translations?.COMMON_MSG?.SUBMIT}</button>
                </div>
      }
        </div>
    </div>
    </div>
    </div>

  );
}
